import React from 'react';
import { AlertCircleIcon, XIcon, MicIcon, CarIcon } from 'lucide-react';
interface SafetyAlertProps {
  onClose: () => void;
}
export const SafetyAlert = ({
  onClose
}: SafetyAlertProps) => {
  return <div className="bg-red-50 border-2 border-red-500 rounded-lg p-4 mb-6 relative" data-id="element-2795">
      <button onClick={onClose} className="absolute top-2 right-2 text-red-400 hover:text-red-600" aria-label="Close safety alert" data-id="element-2796">
        <XIcon size={18} data-id="element-2797" />
      </button>
      <div className="flex items-start gap-3" data-id="element-2798">
        <AlertCircleIcon size={24} className="text-red-600 flex-shrink-0 mt-0.5" data-id="element-2799" />
        <div data-id="element-2800">
          <h2 className="font-bold text-red-700 text-lg uppercase mb-1" data-id="element-2801">
            SAFETY WARNING
          </h2>
          <p className="text-red-800 font-medium" data-id="element-2802">
            DO NOT use this app while driving. Pull over to a safe location
            before viewing job details or using this application.
          </p>
          <div className="mt-3 flex items-center gap-2 text-red-600" data-id="element-2803">
            <CarIcon size={16} data-id="element-2804" />
            <p className="text-sm" data-id="element-2805">
              Safety is our #1 priority. Please follow all safety protocols.
            </p>
          </div>
          <p className="text-xs text-red-600 mt-2 flex items-center gap-1" data-id="element-2806">
            <MicIcon size={12} data-id="element-2807" />
            Voice-to-text is available for all messaging features
          </p>
        </div>
      </div>
    </div>;
};